import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  * { box-sizing: border-box; }
  a { color: inherit; text-decoration: none; }
  button, input, textarea { font: inherit; }
  /* Better tap behavior on mobile */
  body { -webkit-tap-highlight-color: transparent; }
`;
